import { render, staticRenderFns } from "./PatientsFormMedicalPopup.vue?vue&type=template&id=6f0b4d2a&"
import script from "./PatientsFormMedicalPopup.vue?vue&type=script&lang=js&"
export * from "./PatientsFormMedicalPopup.vue?vue&type=script&lang=js&"
import style0 from "./PatientsFormMedicalPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports